import { motion } from "framer-motion";
import { X, Check } from "lucide-react";
import SectionHeading from "@/components/common/SectionHeading";
import { PROBLEMS, SOLUTIONS } from "@/lib/data";

export default function ProblemSolution() {
  return (
    <section className="py-24 sm:py-32" data-testid="problem-solution">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <SectionHeading
          eyebrow="The student problem"
          title="Job hunting on OPT/H-1B is broken. We fixed it."
          sub="A candid look at what most international students experience — and what SKVY Harmony delivers instead."
        />

        <div className="grid md:grid-cols-2 gap-6 lg:gap-8 mt-16">
          <div className="rounded-3xl p-8 sm:p-10 border border-white/5" style={{ background: "linear-gradient(180deg, rgba(239,68,68,0.06), transparent)" }}>
            <p className="font-inter text-[11px] uppercase tracking-[0.24em] text-red-400/80 font-semibold mb-6">The old way</p>
            <ul className="space-y-6">
              {PROBLEMS.map((p, i) => (
                <motion.li
                  key={p.title}
                  initial={{ opacity: 0, x: -12 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: i * 0.06 }}
                  className="flex gap-4"
                >
                  <span className="w-9 h-9 rounded-xl bg-red-500/10 border border-red-500/20 flex items-center justify-center shrink-0">
                    <X className="w-4 h-4 text-red-400" />
                  </span>
                  <div>
                    <p className="font-poppins text-white font-medium text-[17px]">{p.title}</p>
                    <p className="font-inter text-sm text-white/50 mt-1">{p.desc}</p>
                  </div>
                </motion.li>
              ))}
            </ul>
          </div>

          <div className="rounded-3xl p-8 sm:p-10 border border-[#10B981]/20 relative overflow-hidden" style={{ background: "linear-gradient(180deg, rgba(16,185,129,0.08), transparent)" }}>
            <div className="absolute -top-24 -right-24 w-64 h-64 rounded-full blur-3xl opacity-30" style={{ background: "#10B981" }} />
            <p className="relative font-inter text-[11px] uppercase tracking-[0.24em] text-[#10B981] font-semibold mb-6">The SKVY Harmony way</p>
            <ul className="relative space-y-6">
              {SOLUTIONS.map((p, i) => (
                <motion.li
                  key={p.title}
                  initial={{ opacity: 0, x: 12 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: i * 0.06 }}
                  className="flex gap-4"
                >
                  <span className="w-9 h-9 rounded-xl bg-[#10B981]/15 border border-[#10B981]/30 flex items-center justify-center shrink-0">
                    <Check className="w-4 h-4 text-[#10B981]" />
                  </span>
                  <div>
                    <p className="font-poppins text-white font-medium text-[17px]">{p.title}</p>
                    <p className="font-inter text-sm text-white/60 mt-1">{p.desc}</p>
                  </div>
                </motion.li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
